<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.store')"
    resource="stores"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import { WEEKDAYS } from '@/constants';
import { filterColumnsHash, columnsHash, formColumnsHash } from '../admin_configs/stores/columns';

@Component
export default class Stores extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}
  businessHoursColumns = [
    {
      prop: 'begin_weekday',
      label: this.$t('businessHour.beginWeekday'),
      renderCell: (h, { props: { value } }) => {
        return <span>{ this.$t(`businessHour.weekdays.${value}`) }</span>;
      }
    },
    {
      prop: 'end_weekday',
      label: this.$t('businessHour.endWeekday'),
      renderCell: (h, { props: { value } }) => {
        return <span>{ this.$t(`businessHour.weekdays.${value}`) }</span>;
      }
    },
    {
      prop: 'begin_hour',
      label: this.$t('businessHour.beginHour'),
    },
    {
      prop: 'end_hour',
      label: this.$t('businessHour.endHour'),
    },
  ]

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      { prop: 'name_cont' },
      { prop: 'kind_eq' },
      { prop: 'status_eq' },
      { prop: 'country_id_eq' },
    ].filter(Boolean).map(hash => _.merge(filterColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    return [
      { prop: 'id' },
      { prop: 'name' },
      { prop: 'email' },
      { prop: 'phone' },
      { prop: 'kind' },
      { prop: 'status' },
      {
        prop: 'country_id',
        renderCell: (h, { props: { scope: { row } } }) => {
          if (row.country) {
            return <span>{row.country.name}</span>;
          }
        },
      },
      type === 'show' && { prop: 'address' },
      type === 'show' && { prop: 'latitude' },
      type === 'show' && { prop: 'longitude' },
      type === 'show' && { prop: 'images' },
      type === 'show' && {
        prop: 'business_hours_attributes',
        label: this.$t('store.businessHour'),
        renderCell: (h, { props: { value } }) => {
          return <bean-table style={{ width: '800px' }} value={value} columns={this.businessHoursColumns} />;
        }
      },
      type === 'show' && { prop: 'mini_program_path', label: this.$t('product.miniProgramPath') },
      { prop: 'wxacode' },
      type === 'show' && { prop: 'created_at' },
      type === 'show' && { prop: 'updated_at' },
    ].filter(Boolean).map(hash => _.merge(columnsHash[hash['prop']], hash))
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      { prop: 'name' },
      { prop: 'email' },
      { prop: 'phone' },
      { prop: 'address' },
      { prop: 'kind' },
      { prop: 'status' },
      { prop: 'latitude' },
      { prop: 'longitude' },
      { prop: 'country_id' },
      {
        prop: 'images',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 375x288`,
          props: {
            limit: 9,
          }
        }
      },
      {
        prop: 'business_hours_attributes',
        label: this.$t('store.businessHour'),
        renderCell: {
          component: 'nestForm',
          required: true,
          props: {
            columns: [
              {
                prop: 'begin_weekday',
                label: this.$t('businessHour.beginWeekday'),
                renderCell: {
                  component: 'select',
                  required: true,
                  props: {
                    options: _.map(WEEKDAYS, (value) => ({ label: this.$t(`businessHour.weekdays.${value}`), value: value }))
                  }
                }
              },
              {
                prop: 'end_weekday',
                label: this.$t('businessHour.endWeekday'),
                renderCell: {
                  component: 'select',
                  required: true,
                  props: {
                    options: _.map(WEEKDAYS, (value) => ({ label: this.$t(`businessHour.weekdays.${value}`), value: value }))
                  }
                }
              },
              {
                prop: 'begin_hour',
                label: this.$t('businessHour.beginHour'),
                renderCell: {
                  component: 'timePicker',
                  required: true,
                  props: {
                    clearable: false,
                    format: 'HH:mm',
                    'value-format': 'HH:mm'
                  }
                }
              },
              {
                prop: 'end_hour',
                label: this.$t('businessHour.endHour'),
                renderCell: {
                  component: 'timePicker',
                  required: true,
                  props: {
                    clearable: false,
                    format: 'HH:mm',
                    'value-format': 'HH:mm'
                  }
                }
              },
            ]
          }
        }
      }
    ].filter(Boolean).map(hash => _.merge(formColumnsHash[hash['prop']], hash))
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'stores.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'stores.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/stores',
    name: 'stores.index',
    component: Stores,
    props: {
      type: 'index',
    }
  },
  {
    path: '/stores/new',
    name: 'stores.new',
    component: Stores,
    props: {
      type: 'new',
    }
  },
  {
    path: '/stores/:id',
    name: 'stores.show',
    component: Stores,
    props: {
      type: 'show',
    }
  },
  {
    path: '/stores/:id/edit',
    name: 'stores.edit',
    component: Stores,
    props: {
      type: 'edit'
    }
  }
]
</script>
